/* eslint-disable react/no-array-index-key */
import { useState , useEffect } from 'react'
import styles from './styles.module.sass'

const HierarchicalMenu = (props) => {
    const {
        categories,
        setListCategories,
        actualFilters,
        resetFilters,
        singleSelector = false
    } = props


    const [ verMas, setVerMas ] = useState(false)
    const [ typeComponent, setTypeComponent ] = useState('checkbox')
    const [ activeCategories, setActiveCategoies ] = useState(actualFilters?.categories)
    const [ catDisable, setCatDisable ] = useState(null)
    
    const [ catLvl0, setLvl0 ] = useState(null)
    const [ catLvl1, setLvl1 ] = useState(null)
    const handleClick = ({name, id = null}) => {
        const catName = name
        const catID = id

        const categoryObject = {
            lvl0: catName,
            lvl1: null,
            lvl2: null,
            id: catID
        }

        setLvl0(catName)
        setLvl1(null)

        if(!singleSelector){
            if( activeCategories?.find( existe => existe.lvl0 === categoryObject.lvl0 ) ){
                setActiveCategoies([])
            }
            else{
                setActiveCategoies( [categoryObject] )
            }
        }
        else {
            // eslint-disable-next-line no-lonely-if
            if( activeCategories?.find( existe => existe.lvl0 === categoryObject.lvl0 ) ){
                setActiveCategoies([])
            }
            else{
                setActiveCategoies( [categoryObject] )
            }
        }  
    }

    const handleClickLvl2 = ({name, id = null}) => {
        const catName = name
        const catID = id

        const categoryObject = {
            lvl0: catLvl0,
            lvl1: catName,
            lvl2: null,
            id: catID
        }
        setLvl1(catName)
        if( activeCategories?.find( existe => existe.lvl1 === categoryObject.lvl1 ) ){
            setActiveCategoies([])
        }
        else{
            setActiveCategoies( [categoryObject] )
        }
    }

    const handleClickLvl3 = ({name, id = null}) => {
        const catName = name
        const catID = id

        const categoryObject = {
            lvl0: catLvl0,
            lvl1: catLvl1,
            lvl2: catName,
            id: catID
        }
        if( activeCategories?.find( existe => existe.lvl2 === categoryObject.lvl2 ) ){
            // setActiveCategoies([catLvl1])
            const preObject = {
                lvl0: catLvl0,
                lvl1: catLvl1,
                lvl2: null,
                id: catID
            }
            setActiveCategoies([preObject])
        }
        else{
            setActiveCategoies( [categoryObject] )
        }
    }


    useEffect(()=>{
        if(categories){
            const categoryObject = {
                lvl0: categories[0]?.name,
                lvl1: null,
                lvl2: null
            }
            setLvl0(categories[0]?.name)
            setCatDisable(categoryObject)
        }
    },[categories])

    useEffect(()=>{
        if(singleSelector){
            setTypeComponent('checkbox')
        }
    },[singleSelector])

    useEffect(()=>{
        setListCategories(activeCategories)
        // console.log('activeCategories: ', activeCategories)
    },[activeCategories])

    useEffect(()=>{
        if(resetFilters){
            setActiveCategoies([])
        }
    },[resetFilters])


    return(
        <div className={styles?.contenidoCategorias}>

            <div className={styles?.seccionSuperior}>
                <p className={styles?.h2}>Departamentos</p>
            </div>

            <div className={styles?.iteracion}>
                <ul>
                    {categories?.map((lvl0, index) => (
                        verMas === false
                            ? index <= 4 &&
                                <CategoryFilter
                                    key={ index }
                                    lvl0={ lvl0 }
                                    index={ index }
                                    activeCategories={ activeCategories }
                                    typeComponent={ typeComponent }
                                    handleClick={ handleClick }
                                    handleClickLvl2={ handleClickLvl2 }
                                    handleClickLvl3={ handleClickLvl3 }
                                    catDisable={catDisable}
                                />
                            : (
                                <CategoryFilter
                                    key={ index }
                                    lvl0={ lvl0 }
                                    index={ index }
                                    activeCategories={ activeCategories }
                                    typeComponent={ typeComponent }
                                    handleClick={ handleClick }
                                    handleClickLvl2={ handleClickLvl2 }
                                    handleClickLvl3={ handleClickLvl3 }
                                    catDisable={catDisable}
                                />
                            )
                        ))}
                </ul>
                {categories?.length > 5
                    ?
                        <div className={styles?.boxVerMasCategorias}>
                            {verMas === false
                                ? <p onClick={() => setVerMas(!verMas)} aria-hidden="true" className="textoVerMas"> Ver más</p>
                                : <p onClick={() => setVerMas(!verMas)} aria-hidden="true" className="textoVerMenos"> Ver menos</p>
                            }
                        </div>
                    : null
                }
            </div>
        </div>
    )   
}

const CategoryFilter = ( props ) => {

    const {
        lvl0, 
        index,
        handleClick,
        handleClickLvl2,
        handleClickLvl3,
        activeCategories,
        typeComponent,
        catDisable
    } = props

    return(
        <li key={`categ_${index}`} className={styles?.listTitles}>
            <label 
                className={styles?.labelClass} 
                htmlFor={`lvl0_${lvl0?.name}${lvl0?.id}`}
            >{lvl0?.name}</label>
            <input
                className={styles?.radio} 
                type={typeComponent}
                name="category"
                id={`lvl0_${lvl0?.name}${lvl0?.id}`} 
                onChange={ () => handleClick( { name: lvl0?.name, id: lvl0?.id } ) }
                checked={ Boolean(activeCategories.find(valor => valor?.lvl0 === lvl0?.name)) || catDisable?.lvl0 === lvl0?.name.toLowerCase()}
                disabled={catDisable?.lvl0 === lvl0?.name.toLowerCase()} 
            />
            {lvl0?.data
                ?
                    <ul>
                        {
                            lvl0?.data.map((lvl1, index1) => (
                                <li key={`categ_${index1}`} className={styles?.listTitlesInt}>
                                    <label 
                                        className={styles?.labelClass} 
                                        htmlFor={`lvl1_${lvl1?.name}${lvl1?.id}`}
                                    >{lvl1?.name}</label>
                                     <input
                                        className={styles?.radio} 
                                        type={typeComponent}
                                        name="category"
                                        id={`lvl1_${lvl1?.name}${lvl1?.id}`} 
                                        onChange={ () => handleClickLvl2( { name: lvl1?.name, id: lvl1?.id } ) }
                                        checked={ Boolean(activeCategories.find(valor => valor?.lvl1 === lvl1?.name)) }
                                    />
                                    {lvl1?.data
                                        ?
                                            <ul>
                                                {
                                                    lvl1?.data.map((lvl2, index2) => (
                                                        <li key={`categ_${index2}`} className={styles?.listTitlesInt2}>
                                                            <label 
                                                                className={styles?.labelClass} 
                                                                htmlFor={`lvl2_${lvl2?.name}${lvl2?.id}`}
                                                            >{lvl2?.name}</label>
                                                            <input
                                                                className={styles?.radio} 
                                                                type={typeComponent}
                                                                name="category"
                                                                id={`lvl2_${lvl2?.name}${lvl2?.id}`} 
                                                                onChange={ () => handleClickLvl3( { name: lvl2?.name, id: lvl2?.id } ) }
                                                                checked={ Boolean(activeCategories.find(valor => valor?.lvl2 === lvl2?.name)) }
                                                            />
                                                        </li>
                                                    )) 
                                                }
                                            </ul>
                                        : null
                                    }
                                </li>
                            )) 
                        }
                    </ul>
                : null
            }
        </li>
    )
}

export default HierarchicalMenu